import { render } from "./ItemActions.vue?vue&type=template&id=7267c644&ts=true"
import script from "./ItemActions.vue?vue&type=script&setup=true&lang=ts"
export * from "./ItemActions.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/item/ItemActions.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7267c644"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7267c644', __exports__)) {
    api.reload('7267c644', __exports__)
  }
  
  module.hot.accept("./ItemActions.vue?vue&type=template&id=7267c644&ts=true", () => {
    api.rerender('7267c644', render)
  })

}


export default __exports__